import { render, staticRenderFns } from "./DealNotifications.vue?vue&type=template&id=7988df2c&scoped=true&"
import script from "./DealNotifications.vue?vue&type=script&lang=js&"
export * from "./DealNotifications.vue?vue&type=script&lang=js&"
import style0 from "./DealNotifications.vue?vue&type=style&index=0&id=7988df2c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7988df2c",
  null
  
)

export default component.exports